import { Controller } from "@hotwired/stimulus";

const CHECK_CIRCLE_ICON = `<svg height="16" class="kolidecon kolidecon-check-circle" viewBox="0 0 24 24" version="1.1" width="16" aria-hidden="true">
  <path fill-rule="evenodd" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm5.722 5.124a.8.8 0 0 0-.997.113l-6.288 6.427-1.877-1.753a.944.944 0 0 0-1.23-.043.869.869 0 0 0-.175 1.176l2.43 3.513c.065.094.147.177.24.245.458.33 1.104.238 1.444-.205l6.61-8.617a.586.586 0 0 0-.157-.856z"></path>
</svg>`;

const X_CIRCLE_ICON = `<svg height="16" class="kolidecon kolidecon-x-circle" viewBox="0 0 24 24" version="1.1" width="16" aria-hidden="true">
  <path fill-rule="evenodd" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10C6.478 22 2 17.523 2 12S6.478 2 12 2zM8.71 7.293a1 1 0 0 0-1.414 1.414l3.29 3.292-3.293 3.294a1 1 0 0 0 1.414 1.414l3.294-3.293 3.292 3.293a1 1 0 1 0 1.414-1.414l-3.292-3.294 3.292-3.292a1 1 0 1 0-1.414-1.414L12 10.585z"></path>
</svg>`;

// Controls the "Require Signed AuthnRequests" checkbox interaction with the
// certificate textarea. The checkbox is disabled when no certificate content
// is present. When toggled on, an async validation request confirms the
// certificate is parseable before allowing the form to be saved.
export default class extends Controller {
  static targets = ["checkbox", "certificate", "status"];
  static values = {
    validationUrl: String,
  };

  connect() {
    this.syncCheckboxState();
  }

  // Called when the certificate textarea content changes
  certificateChanged() {
    this.clearStatus();
    this.checkboxTarget.checked = false;
    this.syncCheckboxState();
  }

  // Called when the checkbox is toggled
  async checkboxToggled() {
    if (!this.checkboxTarget.checked) {
      this.clearStatus();
      return;
    }

    // Validate the certificate when enabling enforcement
    const certificate = this.certificateTarget.value.trim();
    if (!certificate) {
      this.checkboxTarget.checked = false;
      return;
    }

    this.setStatus("Validating...", "info");

    try {
      const response = await fetch(this.validationUrlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector(
            'meta[name="csrf-token"]'
          )?.content,
        },
        body: JSON.stringify({ certificate: certificate }),
      });

      if (response.ok) {
        this.setStatus(CHECK_CIRCLE_ICON, "success");
      } else {
        this.setStatus(`${X_CIRCLE_ICON} Invalid certificate`, "error");
        this.checkboxTarget.checked = false;
      }
    } catch {
      this.setStatus(`${X_CIRCLE_ICON} Validation failed`, "error");
      this.checkboxTarget.checked = false;
    }
  }

  syncCheckboxState() {
    const hasCertificate = this.certificateTarget.value.trim().length > 0;
    this.checkboxTarget.disabled = !hasCertificate;

    if (!hasCertificate && this.checkboxTarget.checked) {
      this.checkboxTarget.checked = false;
      this.clearStatus();
    }
  }

  setStatus(html, type) {
    if (!this.hasStatusTarget) return;
    this.statusTarget.innerHTML = html;
    this.statusTarget.className = `idp-enforcement-status idp-enforcement-status--${type}`;
    this.statusTarget.hidden = false;
  }

  clearStatus() {
    if (!this.hasStatusTarget) return;
    this.statusTarget.innerHTML = "";
    this.statusTarget.hidden = true;
  }
}
